import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=e654b140&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=e654b140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e654b140",
  null
  
)

export default component.exports